"use client";

import { cn } from "@/lib/utils";
import moment from "moment";
import { useEffect, useState } from "react";

export default function BackgroundStaticLite() {
  const getSunrise = () => {
    const hour = moment().hour();

    if (hour) {
      switch (true) {
        case hour >= 5 && hour < 9:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(255,205,128,0.3),rgba(255,255,255,0))]";
        case hour >= 9 && hour < 10:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(255,219,0,0.3),rgba(255,255,255,0))]";
        case hour >= 10 && hour < 18:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(169,241,246,0.3),rgba(255,255,255,0))]";
        case hour >= 18 && hour < 20:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(232,129,127,0.3),rgba(255,255,255,0))]";
        case hour >= 20 && hour < 24:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(49,31,98,0.3),rgba(255,255,255,0))]";
        default:
          return "bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(80,110,200,0.3),rgba(255,255,255,0))]";
      }
    }
    return "";
  };

  const [sunrise, setSunrise] = useState("");
  useEffect(() => {
    setSunrise(getSunrise);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className={cn("fixed top-0 z-[-2] h-screen w-screen", sunrise)} />
      <div className="fixed top-0 bg-[#f4f5f6] dark:bg-[#131517] h-screen w-screen -z-50" />
      <div className="fixed inset-0 -z-10 h-full w-full items-center px-5 py-24 [background:radial-gradient(125%_125%_at_50%_10%,#00000000_40%,#0099FF10_100%)]"></div>
    </>
  );
}
